import { render, staticRenderFns } from "./PemeliharaanAsetPage.vue?vue&type=template&id=36f3c053"
import script from "./PemeliharaanAsetPage.vue?vue&type=script&lang=js"
export * from "./PemeliharaanAsetPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports